(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function productRow(product) {
    var image = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" width="96" height="96" loading="lazy">'
      : '<span aria-hidden="true"></span>';
    var type = product.type ? '<span>' + escapeHtml(product.type) + '</span>' : '';
    var sku = product.sku ? '<span>' + escapeHtml(product.sku) + '</span>' : '';
    var fulfillment = (product.vendor || '').toLowerCase().indexOf('container modification world') !== -1
      ? '<span>CMW fulfilled</span>'
      : '';
    var meta = type + sku + fulfillment;
    return [
      '<article class="tcg-hub-catalogue__item" data-tcg-catalogue-item data-category="' + escapeHtml(product.category) + '" data-search="' + escapeHtml(product.search) + '">',
      '  <a class="tcg-hub-catalogue__main" href="' + escapeHtml(product.url) + '">',
      '    <span class="tcg-hub-catalogue__image">' + image + '</span>',
      '    <span class="tcg-hub-catalogue__copy">',
      '      <span class="tcg-hub-catalogue__title">' + escapeHtml(product.title) + '</span>',
      '      <span class="tcg-hub-catalogue__summary">' + escapeHtml(product.summary) + '</span>',
      meta ? '      <span class="tcg-hub-catalogue__meta">' + meta + '</span>' : '',
      '    </span>',
      '    <span class="tcg-hub-catalogue__price">' + escapeHtml(product.price) + '</span>',
      '  </a>',
      '  <a class="tcg-hub-catalogue__action" href="' + escapeHtml(product.url) + '">View product</a>',
      '</article>',
    ].join('');
  }

  function render(root, data) {
    if (!root || root.dataset.tcgCatalogueReady === 'true') return;
    root.dataset.tcgCatalogueReady = 'true';

    var filters = root.querySelector('[data-tcg-catalogue-filters]');
    var groups = root.querySelector('[data-tcg-catalogue-groups]');
    var search = root.querySelector('[data-tcg-catalogue-search]');
    var clear = root.querySelector('[data-tcg-catalogue-clear]');
    var count = root.querySelector('[data-tcg-catalogue-count]');
    var empty = root.querySelector('[data-tcg-catalogue-empty]');
    var expand = root.querySelector('[data-tcg-catalogue-expand]');
    var collapse = root.querySelector('[data-tcg-catalogue-collapse]');
    if (!filters || !groups || !search || !clear || !count || !empty) return;

    var activeCategory = 'all';
    var categories = data.categories.filter(function (category) {
      return category.count > 0;
    });
    var products = data.products || [];
    var openCategories = {};
    var defaultOpenCategory = categories[0] ? categories[0].slug : '';
    categories.forEach(function (category) {
      openCategories[category.slug] = category.slug === defaultOpenCategory;
    });

    filters.innerHTML = [
      '<button type="button" class="tcg-hub-catalogue__filter is-active" data-category="all" aria-pressed="true">All <span>' + products.length + '</span></button>',
    ].concat(categories.map(function (category) {
      return '<button type="button" class="tcg-hub-catalogue__filter" data-category="' + escapeHtml(category.slug) + '" aria-pressed="false">' + escapeHtml(category.label) + ' <span>' + category.count + '</span></button>';
    })).join('');

    groups.innerHTML = categories.map(function (category) {
      var categoryProducts = products.filter(function (product) {
        return product.category === category.slug;
      });
      var listId = 'parts-' + escapeHtml(category.slug) + '-list';
      return [
        '<section class="tcg-hub-catalogue__group" data-tcg-catalogue-group data-category="' + escapeHtml(category.slug) + '" id="parts-' + escapeHtml(category.slug) + '">',
        '  <button type="button" class="tcg-hub-catalogue__group-toggle" data-tcg-catalogue-toggle data-category="' + escapeHtml(category.slug) + '" aria-expanded="false" aria-controls="' + listId + '">',
        '    <span class="tcg-hub-catalogue__group-title">',
        '      <span class="tcg-hub-card__meta">' + escapeHtml(category.count + ' products') + '</span>',
        '      <span>' + escapeHtml(category.label) + '</span>',
        '    </span>',
        '    <span class="tcg-hub-catalogue__group-short">' + escapeHtml(category.short) + '</span>',
        '    <span class="tcg-hub-catalogue__group-icon" aria-hidden="true">+</span>',
        '  </button>',
        '  <div class="tcg-hub-catalogue__list" id="' + listId + '" hidden>',
        categoryProducts.map(productRow).join(''),
        '  </div>',
        '</section>',
      ].join('');
    }).join('');

    function setGroupOpen(group, open) {
      var category = group.dataset.category;
      var toggle = group.querySelector('[data-tcg-catalogue-toggle]');
      var list = group.querySelector('.tcg-hub-catalogue__list');
      var icon = group.querySelector('.tcg-hub-catalogue__group-icon');
      openCategories[category] = open;
      group.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (list) list.hidden = !open;
      if (icon) icon.textContent = open ? '-' : '+';
      syncBulkButtons();
    }

    function syncGroupOpenStates() {
      root.querySelectorAll('[data-tcg-catalogue-group]').forEach(function (group) {
        setGroupOpen(group, !!openCategories[group.dataset.category]);
      });
      syncBulkButtons();
    }

    function visibleGroups() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-tcg-catalogue-group]')).filter(function (group) {
        return !group.hidden;
      });
    }

    function syncBulkButtons() {
      if (!expand || !collapse) return;
      var visible = visibleGroups();
      var openVisible = visible.filter(function (group) {
        return !!openCategories[group.dataset.category];
      });
      expand.disabled = visible.length > 0 && openVisible.length === visible.length;
      collapse.disabled = openVisible.length === 0;
    }

    function applyFilters() {
      var query = search.value.trim().toLowerCase();
      var visibleCount = 0;
      var groupNodes = root.querySelectorAll('[data-tcg-catalogue-group]');
      var itemNodes = root.querySelectorAll('[data-tcg-catalogue-item]');

      itemNodes.forEach(function (item) {
        var categoryMatches = activeCategory === 'all' || item.dataset.category === activeCategory;
        var searchMatches = !query || (item.dataset.search || '').indexOf(query) !== -1;
        var visible = categoryMatches && searchMatches;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      groupNodes.forEach(function (group) {
        var anyVisible = !!group.querySelector('[data-tcg-catalogue-item]:not([hidden])');
        var categoryVisible = activeCategory === 'all' || group.dataset.category === activeCategory;
        group.hidden = !(anyVisible && categoryVisible);
      });

      count.textContent = visibleCount + (visibleCount === 1 ? ' product' : ' products');
      clear.hidden = search.value.trim() === '';
      empty.hidden = visibleCount !== 0;
      syncGroupOpenStates();
    }

    function openVisibleGroups() {
      root.querySelectorAll('[data-tcg-catalogue-group]').forEach(function (group) {
        var hasVisibleProducts = !!group.querySelector('[data-tcg-catalogue-item]:not([hidden])');
        openCategories[group.dataset.category] = !group.hidden && hasVisibleProducts;
      });
      syncGroupOpenStates();
    }

    function setVisibleGroupsOpen(open) {
      visibleGroups().forEach(function (group) {
        openCategories[group.dataset.category] = open;
      });
      syncGroupOpenStates();
    }

    function openDefaultGroup() {
      Object.keys(openCategories).forEach(function (category) {
        openCategories[category] = category === defaultOpenCategory;
      });
      syncGroupOpenStates();
    }

    filters.querySelectorAll('button[data-category]').forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.dataset.category || 'all';
        filters.querySelectorAll('button[data-category]').forEach(function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        applyFilters();
        if (activeCategory === 'all' && search.value.trim() === '') {
          openDefaultGroup();
        } else {
          openVisibleGroups();
        }
      });
    });

    filters.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target;
      if (!target || !target.matches || !target.matches('button[data-category]')) return;
      event.preventDefault();
      activeCategory = target.dataset.category || 'all';
      filters.querySelectorAll('button[data-category]').forEach(function (candidate) {
        var selected = candidate === target;
        candidate.classList.toggle('is-active', selected);
        candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      applyFilters();
      if (activeCategory === 'all' && search.value.trim() === '') {
        openDefaultGroup();
      } else {
        openVisibleGroups();
      }
    });

    root.querySelectorAll('[data-tcg-catalogue-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var group = toggle.closest('[data-tcg-catalogue-group]');
        if (!group) return;
        setGroupOpen(group, !openCategories[group.dataset.category]);
      });
    });

    if (expand) {
      expand.addEventListener('click', function () {
        setVisibleGroupsOpen(true);
      });
    }

    if (collapse) {
      collapse.addEventListener('click', function () {
        setVisibleGroupsOpen(false);
      });
    }

    search.addEventListener('input', function () {
      applyFilters();
      if (search.value.trim() === '' && activeCategory === 'all') {
        openDefaultGroup();
      } else {
        openVisibleGroups();
      }
    });
    clear.addEventListener('click', function () {
      search.value = '';
      applyFilters();
      if (activeCategory === 'all') {
        openDefaultGroup();
      } else {
        openVisibleGroups();
      }
      search.focus();
    });
    applyFilters();
  }

  function init() {
    var data = window.tcgPartsCatalogueData;
    document.querySelectorAll('[data-tcg-catalogue]').forEach(function (root) {
      if (!data || !Array.isArray(data.products)) {
        var empty = root.querySelector('[data-tcg-catalogue-empty]');
        if (empty) {
          empty.hidden = false;
          empty.textContent = 'Parts catalogue data is not available in this preview.';
        }
        return;
      }
      render(root, data);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
